import React, { useState, useEffect } from "react";
import { DatePicker, Input, Select, Switch } from "antd";
import moment from "moment";
import { ErrorToast } from "../../../../../widgets/AppToast";
import { post } from "../../../../../services/services";
import { ApiURL } from "../../../../../services/apiConstants";
import UnitWithInput from "../../../../../components/UnitWithInput";

// Map parameter names to labels and unit options
const parameterConfig = {
  turbinespeedrpm: { label: "Turbine Speed (RPM)", unitList: [] },
  steaminletpressurempa: { label: "Steam Inlet Pressure (MPa)", unitList: [] },
  steaminlettemperaturec: { label: "Steam Inlet Temperature (°C)", unitList: [] },
  steamexhaustpressurempa: { label: "Steam Exhaust Pressure (MPa)", unitList: [] },
  bearingtemp1turbinec: { label: "Bearing Temp 1 Turbine (°C)", unitList: [] },
  bearingtemp2turbinec: { label: "Bearing Temp 2 Turbine (°C)", unitList: [] },
  "vibration-horizontalturbinemmsrms": {
    label: "Vibration - Horizontal Turbine (mm/s RMS)",
    unitList: [],
  },
  "vibration-verticalturbinemmsrms": {
    label: "Vibration - Vertical Turbine (mm/s RMS)",
    unitList: [],
  },
  "vibration-axialturbinemmsrms": { label: "Vibration - Axial Turbine (mm/s RMS)", unitList: [] },
  lubeoilpressurempa: { label: "Lube Oil Pressure (MPa)", unitList: [] },
  lubeoiltemperaturec: { label: "Lube Oil Temperature (°C)", unitList: [] },
  condensatedischargepressurempa: { label: "Condensate Discharge Pressure (MPa)", unitList: [] },
  crudeoiltempatinletc: { label: "Crude Oil Temp at Inlet (°C)", unitList: [] },
  washinggunsactivenumber: { label: "Washing Guns Active Number", unitList: [] },
  washingcyclestage: { label: "Washing Cycle Stage", unitList: [] },
  washingdurationminutes: { label: "Washing Duration (Minutes)", unitList: [] },
  tankbeingwashed: { label: "Tank Being Washed", unitList: [] },
  pumpdischargepressurempa: { label: "Pump Discharge Pressure (MPa)", unitList: [] },
  pumpsuctionpressurempa: { label: "Pump Suction Pressure (MPa)", unitList: [] },
  // flowratem³hr: { label: "Flow Rate (m³/hr)", unitList: [] },
  pumpspeedrpm: { label: "Pump Speed (RPM)", unitList: [] },
  bearingtemp1pumpc: { label: "Bearing Temp 1 Pump (°C)", unitList: [] },
  bearingtemp2pumpc: { label: "Bearing Temp 2 Pump (°C)", unitList: [] },
  "vibration-horizontalpumpmmsrms": {
    label: "Vibration - Horizontal Pump (mm/s RMS)",
    unitList: [],
  },
  "vibration-verticalpumpmmsrms": { label: "Vibration - Vertical Pump (mm/s RMS)", unitList: [] },
  "vibration-axialpumpmmsrms": { label: "Vibration - Axial Pump (mm/s RMS)", unitList: [] },
  stuffingboxleakagequalitative: { label: "Stuffing Box Leakage (Qualitative)", unitList: [] },
  ambienttemperaturec: { label: "Ambient Temperature (°C)", unitList: [] },
  "humidity%rh": { label: "Humidity (% RH)", unitList: [] },
  operationballastingdeballasting: {
    label: "Operation (Ballasting/Deballasting)",
    unitList: [],
    dropdownOptions: ["Ballasting", "Deballasting"],
  },
  operationhours: { label: "Operation Hours", unitList: [] },
  totaloperationhours: { label: "Total Operation Hours", unitList: [] },
};

export const CoptCom = ({ eng_log_basic_id, _items }) => {
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    logDate: moment().format("YYYY-MM-DD HH:mm:ss"),
    parameters: {},
    otherParams: {},
  });
  const [checked, setChecked] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(false);

  useEffect(() => {
  
    const initialParameters = (_items?.selected_parameters || []).reduce((acc, param) => {
      if (parameterConfig[param]) {
        acc[param] = { value: "", unit: parameterConfig[param].unitList[0] || "" };
      }
      return acc;
    }, {});

    const initialOtherParams = (_items?.other_parameters || []).reduce((acc, param) => {
      acc[param.name] = { value: param.value || "", unit: param.unit || "" };
      return acc;
    }, {});

    setFormData((prev) => ({
      ...prev,
      parameters: initialParameters,
      otherParams: initialOtherParams,
    }));

      VIEW_NITROGEN_LOGBOOK_API(_items.id);
    
  }, [_items?.id]);

  // Handle date/time change
  const onChangeDateTime = (value) => {
    setFormData((prev) => ({
      ...prev,
      logDate: value ? value.format("YYYY-MM-DD HH:mm:ss") : null,
    }));
  };

  // Handle parameter value/unit change
  const updateParameter = (param, field, value) => {
    setFormData((prev) => ({
      ...prev,
      parameters: {
        ...prev.parameters,
        [param]: { ...prev.parameters[param], [field]: value },
      },
    }));
  };

  // Handle other parameter value/unit change
  const updateOtherParam = (name, field, value) => {
    setFormData((prev) => ({
      ...prev,
      otherParams: {
        ...prev.otherParams,
        [name]: { ...prev.otherParams[name], [field]: value },
      },
    }));
  };


 

  // API to view logbook details
  const VIEW_NITROGEN_LOGBOOK_API = async (copt_id, staff_dashboard) => {
   
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("copt_id", copt_id);
      FORM_DATA.append("eng_log_basic_id", eng_log_basic_id);
      FORM_DATA.append("voyage_id", staff_dashboard?.voyage_details?.[0]?.id);
      post(ApiURL.edit_view_copt_info_machinery_com, FORM_DATA).then((res) => {
        if (res?.status === true) {
          const coptData = res?.response_data;
          setUpdateStatus(coptData?.complete_status || false);
          setSubmitStatus(true);
          setChecked(coptData?.copt_on_off || false);
          const parameters = Object.keys(coptData?.selected_parameters || {}).reduce(
            (acc, param) => {
              const paramData = coptData.selected_parameters[param] || { value: 0, unit: "" };
              acc[param] = {
                value: paramData.value !== undefined ? paramData.value.toString() : "0",
                unit: paramData.unit || parameterConfig[param]?.unitList[0] || "",
              };
              return acc;
            },
            {}
          );

          setFormData((prev) => {
        
            return {
              ...prev,
              logDate: coptData?.date_time_log || moment().format("YYYY-MM-DD HH:mm:ss"),
              parameters,

              otherParams:
                coptData?.other_parameters && Object.keys(coptData.other_parameters).length
                  ? Object.keys(coptData.other_parameters).reduce((acc, key) => {
                      const paramData = coptData.other_parameters[key] || { value: "", unit: "" };
                      acc[key] = {
                        value: paramData.value !== undefined ? paramData.value.toString() : "",
                        unit: paramData.unit || "",
                      };
                      return acc;
                    }, {})
                  : prev.otherParams,
            };
          });
        } else {
          setErrors(res?.errors || {});
          ErrorToast("Error", "Failed to fetch logbook details.");
        }
      });
    } catch (error) {
      console.error("Error fetching IGG logbook:", error);
      ErrorToast("Error", "An error occurred while fetching logbook details.");
    }
  };
  // Render
  return (
    <>
      <div className="row custom-box">
        <div className="col-4">
          <b style={{ color: "#161515", fontSize: "14px" }}>
            Machinery Type: {_items?.machinery_type}
          </b>
        </div>
        <div className="col-4">
          <b style={{ color: "#161515", fontSize: "14px" }}>COPT Name: {_items?.copt_name}</b>
        </div>
        <div className="col-4">
          <b style={{ color: "#161515", fontSize: "14px" }}>
          COPT Maker: {_items?.copt_maker}
          </b>
        </div>
        <div className="col-4">
          <b style={{ color: "#161515", fontSize: "14px" }}>
          COPT Model: {_items?.copt__model}
          </b>
        </div>
        <div className="col-4">
          <b style={{ color: "#161515", fontSize: "14px" }}>COPT id: {_items?.id}</b>
        </div>
        <div className="col-2">
          <Switch
            disabled={submitStatus}
            checked={checked}
            // onChange={(value) => {
            //   setChecked(value);
            //   updateStatus
            //     ? UPDATE_NITROGEN_LOGBOOK_API(_items?.id, "0", value)
            //     : ADD_NITROGEN_LOGBOOK_API(_items?.id, value);
            // }}
            checkedChildren="On"
            unCheckedChildren="Off"
            style={{ backgroundColor: checked ? "green" : "red" }}
          />
        </div>
      </div>

      {checked && (
        <>
          {/* Date & Time */}
          <div className="row">
            <div className="col-4">
              <div className="input-box">
                <label>Date & Time</label>
                <DatePicker
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                  placeholder="Select Date & Time"
                  value={formData.logDate ? moment(formData.logDate, "YYYY-MM-DD HH:mm:ss") : null}
                  onChange={onChangeDateTime}
                  style={{ width: "100%" }}
                  disabled={submitStatus}
                  className="custom-input"
                />
                {errors.date_time_log && <p className="error-text">{errors.date_time_log}</p>}
              </div>
            </div>
          </div>

          {/* Selected Parameters */}
          {(() => {
            const rows = [];
            const inputs = (_items?.selected_parameters || [])
              .filter((param) => parameterConfig[param])
              .map((param) => ({
                type: "selectedParam",
                name: param,
                config: parameterConfig[param],
                value: formData.parameters[param]?.value || "",
                unit: formData.parameters[param]?.unit || "",
              }));

            for (let i = 0; i < inputs.length; i += 3) {
              const group = inputs.slice(i, i + 3);
              rows.push(
                <div className="row" key={`param-row-${i}`}>
                  {group.map((input) => (
                    <div className="col-4" key={input.name}>
                      {input.config.dropdownOptions ? (
                        <div className="input-box">
                          <label>{input.config.label}</label>
                          <Select
                            disabled={submitStatus}
                            value={input.value}
                            onChange={(value) => updateParameter(input.name, "value", value)}
                            className="custom-input"
                            style={{ width: "100%" }}
                            placeholder={`Select ${input.config.label}`}
                          >
                            {input.config.dropdownOptions.map((option) => (
                              <Select.Option key={option} value={option}>
                                {option}
                              </Select.Option>
                            ))}
                          </Select>
                          {errors[`pr_${input.name.replace(/([A-Z])/g, "_$1").toLowerCase()}`] && (
                            <p className="error-text">
                              {errors[`pr_${input.name.replace(/([A-Z])/g, "_$1").toLowerCase()}`]}
                            </p>
                          )}
                        </div>
                      ) : input.config.unitList?.length ? (
                        <UnitWithInput
                          label={input.config.label}
                          value={input.value}
                          onChange={(e) => updateParameter(input.name, "value", e.target.value)}
                          unit={input.unit}
                          onUnitChange={(e) => updateParameter(input.name, "unit", e.target.value)}
                          disabled={submitStatus}
                          error={
                            errors[`pr_${input.name.replace(/([A-Z])/g, "_$1").toLowerCase()}`]
                          }
                          unitList={input.config.unitList}
                          className="custom-input"
                        />
                      ) : (
                        <div className="input-box">
                          <label>{input.config.label}</label>
                          <Input
                            disabled={submitStatus}
                            value={input.value}
                            placeholder={input.config.label}
                            onChange={(e) => updateParameter(input.name, "value", e.target.value)}
                            className={`custom-input ${
                              errors[`pr_${input.name.replace(/([A-Z])/g, "_$1").toLowerCase()}`]
                                ? "error"
                                : ""
                            }`}
                          />
                          {errors[`pr_${input.name.replace(/([A-Z])/g, "_$1").toLowerCase()}`] && (
                            <p className="error-text">
                              {errors[`pr_${input.name.replace(/([A-Z])/g, "_$1").toLowerCase()}`]}
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  ))}

                  {group.length < 3 &&
                    Array.from({ length: 3 - group.length }).map((_, idx) => (
                      <div className="col-4" key={`empty-param-${i}-${idx}`}></div>
                    ))}
                </div>
              );
            }
            return rows;
          })()}

          {/* Other Parameters */}
          {(() => {
            const rows = [];
            const otherParamsArray = Object.entries(formData.otherParams || {});
            for (let i = 0; i < otherParamsArray.length; i += 3) {
              const group = otherParamsArray.slice(i, i + 3);
              rows.push(
                <div className="row" key={`other-row-${i}`}>
                  {group.map(([name, { value, unit }]) => (
                    <div className="col-4" key={name}>
                      <UnitWithInput
                        label={name}
                        value={value}
                        onChange={(e) => updateOtherParam(name, "value", e.target.value)}
                        unit={unit}
                        onUnitChange={(e) => updateOtherParam(name, "unit", e.target.value)}
                        disabled={submitStatus}
                        unitList={[unit]}
                        className="custom-input"
                      />
                    </div>
                  ))}
                  {group.length < 3 &&
                    Array.from({ length: 3 - group.length }).map((_, idx) => (
                      <div className="col-4" key={`empty-other-${i}-${idx}`}></div>
                    ))}
                </div>
              );
            }
            return rows;
          })()}

        </>
      )}
    </>
  );
};
